import { ApolloLink, InMemoryCache } from '@apollo/client/core';
import { onError } from '@apollo/client/link/error';
import { setContext } from '@apollo/client/link/context';

import { environment } from '../../environments/environment';
import Keycloak from 'keycloak-js';
import { ApplicationConfig, inject } from '@angular/core';
import { Apollo, APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import extractFiles from 'extract-files/extractFiles.mjs';
import isExtractableFile from 'extract-files/isExtractableFile.mjs';

export function apolloInitializer(): any | void {
  const keycloak = inject(Keycloak);
  const httpLink = inject(HttpLink);
  const token = keycloak.token;

  const authLink = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : '',
      },
    };
  });
  const errorLink = onError(errorResponse => {
    console.error('errorResponse', errorResponse);
    if (errorResponse.graphQLErrors) {
      errorResponse.graphQLErrors.map(value =>
        console.error(
          `[GraphQL error API]: Message: "${value.message}", Operation: ${errorResponse.operation?.operationName}, Path: ${value.path}`,
        ),
      );
    }
    if (errorResponse.networkError) {
      console.error(`[Network error API]: ${errorResponse.networkError}`);
    }
  });
  if (token) {
    const http = httpLink.create({
      uri: environment.graphql_http,
      extractFiles: body => extractFiles(body, isExtractableFile),
    });
    return {
      link: ApolloLink.from([errorLink, authLink.concat(http)]),
      cache: new InMemoryCache(),
    };
  }
}

export const graphqlProvider: ApplicationConfig['providers'] = [
  Apollo,
  {
    provide: APOLLO_OPTIONS,
    useFactory: apolloInitializer
  }
]
